module.exports = "/_next/static/images/award-Telkom-35e6c5b4ef3b7fe19c011f9f94f08794.png";